import { PerimetersService } from './../../../@core/utils/perimeters.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';
import { KPI } from '../../../@core/api';
import { SettingsMenusService, ScopeService, SettingsService } from '../../../@core/utils';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NbButtonModule, NbCheckboxModule, NbPopoverModule } from '@nebular/theme';


@Component({
  selector: 'app-elements-choice-menu',
  templateUrl: './elements-choice-menu.component.html',
  styleUrls: ['./elements-choice-menu.component.scss'],
  standalone: true,
  imports: [NbButtonModule, FontAwesomeModule, NbPopoverModule, NbCheckboxModule, TranslateModule]
})
export class ElementsChoiceMenuComponent implements OnInit, OnDestroy {

  @Input() public menuType: KPI.ElementsChoiceMenuType;

  public elementsChoiceMenu: KPI.ElementsChoiceMenu;
  public displayedElementsMenu: KPI.ElementsMenuItem[] = [];
  public forceHiddenElement: boolean = true;
  private subscriptions: Subscription[] = [];

  constructor(
    private settingsMenusService: SettingsMenusService,
    private scopeService: ScopeService,
    private perimetersService: PerimetersService,
    private settingsService: SettingsService,
  ) { }

  public ngOnInit(): void {
    this.subscriptions.push(
      combineLatest([
        this.settingsMenusService.elementsChoiceMenu(this.menuType),
        this.scopeService.user$,
        this.perimetersService.perimeters$,
        this.settingsService.systemExportReconciliationAriba$,
      ])
        .subscribe(([elementsChoiceMenu, user, perimeters, aribaEnabled]) => {
          this.elementsChoiceMenu = elementsChoiceMenu;
          this.displayedElementsMenu = Object.values(elementsChoiceMenu).filter((elt) =>
            (user.can_access_energy || (!user.can_access_energy && !elt.requireEnergy))
            && (!elt.requireMultipleSites || perimeters.length > 1)
            && (!elt.requireAriba || aribaEnabled)
            && !elt.id.includes('invest_history')
          );
        }),
    );
  }

  public menuChanged(menuId: string): void {
    this.elementsChoiceMenu[menuId].value = !this.elementsChoiceMenu[menuId].value;
    this.settingsMenusService.setElementsChoiceMenu(this.menuType, this.elementsChoiceMenu);
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

}
